import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";
import {RouterModule} from '@angular/router';
import {CurrentGamesComponent} from '@shared/modules/shared-games/components/current-games/current-games.component';
import {LibGamesModule} from '@components/games/lib-games.module';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
  declarations: [
    CurrentGamesComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    LibGamesModule,
    MatButtonModule,
  ],
  exports: [
    CurrentGamesComponent,
  ]
})
export class SharedGamesModule { }
